import { render, staticRenderFns } from "./sales-plan-approve-confirmation.vue?vue&type=template&id=16be6880&scoped=true&"
import script from "./sales-plan-approve-confirmation.vue?vue&type=script&lang=js&"
export * from "./sales-plan-approve-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./sales-plan-approve-confirmation.vue?vue&type=style&index=0&id=16be6880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be6880",
  null
  
)

export default component.exports